import { useEffect, useState } from "react";
import { api } from "../../api";
import { ErrorBanner, Field, inputClass, Panel, PrimaryButton, SecondaryButton, formatTime } from "./ui";

export default function AdminMayors() {
  const [mayors, setMayors] = useState<any[]>([]);
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = () => api.adminMayors().then((r) => setMayors(r.mayors)).catch((e) => setError(e.message));
  useEffect(() => { void load(); }, []);

  const create = async () => {
    setError(""); setMessage("");
    setLoading(true);
    try {
      const result = await api.adminCreateMayor(email.trim(), username.trim());
      setMessage(result.mailSent ? "城主已创建，邀请邮件已发送。" : "城主已创建，但邮件发送失败，可点击重发邀请。");
      setEmail(""); setUsername("");
      await load();
    } catch (e: any) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const resend = async (userId: string) => {
    setError(""); setMessage("");
    try {
      const result = await api.adminResendInvite(userId);
      setMessage(result.mailSent ? "邀请邮件已重发。" : "邮件仍未发送成功，请检查 MAIL 配置。");
    } catch (e: any) {
      setError(e.message);
    }
  };

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-black">城主管理</h1>
        <p className="mt-1 text-sm text-[#77705f]">创建城主账号、发送邀请并查看名下小镇。</p>
      </div>
      <ErrorBanner message={error} />
      {message && <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-800">{message}</div>}
      <Panel title="创建城主">
        <div className="grid gap-4 md:grid-cols-[1fr_1fr_auto] md:items-end">
          <Field label="邮箱">
            <input className={inputClass} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="mayor@example.com" />
          </Field>
          <Field label="用户名">
            <input className={inputClass} value={username} onChange={(e) => setUsername(e.target.value)} placeholder="城主显示名" />
          </Field>
          <PrimaryButton disabled={loading || !email || !username} onClick={create}>
            {loading ? "创建中..." : "创建并发送邀请"}
          </PrimaryButton>
        </div>
      </Panel>
      <Panel title={`城主列表（${mayors.length}）`}>
        <div className="overflow-x-auto">
          <table className="w-full min-w-[760px] text-left text-sm">
            <thead className="border-b border-[#e4dfcf] text-[#77705f]">
              <tr><th className="py-2">用户名</th><th>邮箱</th><th>名下小镇</th><th>创建时间</th><th>状态</th><th /></tr>
            </thead>
            <tbody>
              {mayors.map((mayor) => (
                <tr key={mayor.userId} className="border-b border-[#f0ecdf]">
                  <td className="py-3 font-medium">{mayor.username}</td>
                  <td>{mayor.email}</td>
                  <td>{mayor.townNames || "未分配"}</td>
                  <td>{formatTime(mayor.createdAt)}</td>
                  <td>{mayor.mustChangePassword ? "待首次改密" : "正常"}</td>
                  <td className="text-right">
                    <SecondaryButton onClick={() => resend(mayor.userId)}>重发邀请</SecondaryButton>
                  </td>
                </tr>
              ))}
              {!mayors.length && <tr><td colSpan={6} className="py-8 text-center text-[#918a78]">暂无城主。</td></tr>}
            </tbody>
          </table>
        </div>
      </Panel>
    </div>
  );
}
